<script lang="ts">
  import {
    Button,
    Dropdown,
    RadioButton,
    RadioButtonGroup,
    RadioTile,
    TileGroup,
  } from "carbon-components-svelte";
  import { optionsData } from "../../ts/Stores";
  import Icon from "./Icon.svelte";
  import { Add } from "carbon-icons-svelte";

  export let alignment: string;

  let positioningOptions: string[];
  optionsData.subscribe((optionsData) => {
    positioningOptions =
      optionsData.positioningOptions.horizontalAlignmentOptions;
  });
</script>

<!-- <TileGroup legend="Alignment" bind:selected={alignment}>
  {#each positioningOptions as value}
    <RadioTile {value}><Icon {value} />{value}</RadioTile>
  {/each}
</TileGroup> -->

<RadioButtonGroup
  legendText="Alignment"
  bind:selected={alignment}
  orientation="horizontal"
  class="flex-wrap"
>
  {#each positioningOptions as value}
    <div class="flex-with-icon">
      <RadioButton labelText={value} {value} />
      <Icon {value} />
    </div>
  {/each}
</RadioButtonGroup>
